import React from 'react';
import PropTypes from 'prop-types';


// Container for closing an element (e.g. a modal) when a click is detected
// outside of it. Adapted from: https://stackoverflow.com/a/42234988
export default class ClickOutsideToDismiss extends React.Component {
	static propTypes = {
		onClose: PropTypes.func.isRequired,
		children: PropTypes.element.isRequired,
		active: PropTypes.bool.isRequired,
	};

	componentDidMount() {
		document.addEventListener('click', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutside);
	}

	setWrapperRef = node => {
		this.wrapperRef = node;
	};

	handleClickOutside = e => {
		if (this.props.active && this.wrapperRef && !this.wrapperRef.contains(e.target)) {
			e.preventDefault();
			e.stopPropagation();

			this.props.onClose();
		}
	};

	render() {
		return <div ref={this.setWrapperRef}>{this.props.children}</div>;
	}

}
